export const prune = <T>(input: T): T => {
  if (Array.isArray(input)) {
    // prune each item, then drop items that became empty
    const pruned = input
      .map((item) => prune(item))
      .filter((item) => isMeaningful(item) && !isEmptyObjectOrArray(item));
    return pruned as unknown as T;
  }

  if (typeof input === "object" && input !== null) {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(input)) {
      const pv = prune(v as any);
      if (isMeaningful(pv) && !isEmptyObjectOrArray(pv)) {
        out[k] = pv;
      }
    }
    return out as T;
  }

  return input;
};

const isEmptyObjectOrArray = (v: any): boolean => {
  if (Array.isArray(v)) return v.length === 0;
  if (typeof v === "object" && v !== null) return Object.keys(v).length === 0;
  return false;
};

const isMeaningful = (v: any) =>
  v !== undefined && v !== null && !(typeof v === "string" && v.trim() === "");
